import sharedStyles from '@muiscss/sharedStyles.module.scss'
import { Checkbox } from '..'
import styles from './styles.module.scss'
import { ICheckboxGroupProps } from './types'
import clsx from 'clsx'

const CheckboxGroup = ({
  direction = 'column',
  disabled = false,
  hasError,
  id,
  label,
  onBlur,
  onChange,
  onFocus,
  options,
  required,
  size = 'md',
  style,
  variant = 'default',
  ...props
}: ICheckboxGroupProps) => {
  return (
    <fieldset
      className={clsx('mui-checkbox-group', styles.wrap, styles[size], styles[direction], {
        [sharedStyles.disabled]: disabled,
      })}
      data-testid="test-checkbox-group"
      id={id}
      role="group"
      style={style}
      aria-hidden={disabled}
      {...props}
    >
      {label && (
        <legend
          className={clsx('mui-input-label', styles.title)}
          data-testid="mui-label"
          aria-hidden={disabled}
        >
          {label}
          {required && '*'}
        </legend>
      )}

      {options.map((option) => (
        <Checkbox
          {...option}
          disabled={disabled}
          hasError={hasError}
          key={`${id}_${option.id}`}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          required={required}
          aria-hidden={disabled}
          size={size}
          variant={variant}
        />
      ))}
    </fieldset>
  )
}

export default CheckboxGroup
